import { useState } from 'react';

import styled from 'styled-components';

import { Collapse, CollapseProps } from '@components/animators/collapse';
import { IconButton } from '@components/icon-button';
import { IconDirectionRight } from '@components/icons/direction-right';
import { Stack } from '@components/stack';

import { Card, CardProps } from './card';

export type CollapseCardProps = Pick<CollapseProps, 'keepCollapsedInDom'> &
  CardProps & {
    defaultCollapsed?: boolean;
    renderCollapse(): JSX.Element;
  };

export const CollapseCard = ({
  children,
  defaultCollapsed,
  renderCollapse,
  onClick,
  keepCollapsedInDom,
  ...rest
}: CollapseCardProps) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  return (
    <Card {...rest}>
      <Stack space={4}>
        <Stack
          role="button"
          orientation="horizontal"
          align="center"
          onClick={(event) => {
            setIsCollapsed(!isCollapsed);
            onClick?.(event);
          }}
          style={{ cursor: 'pointer' }}
          space={2}
        >
          <ChildrenContainer>{children}</ChildrenContainer>
          <IconButton
            variant="ghost-purple"
            icon={<IconDirectionRight />}
            style={{ cursor: 'pointer' }}
            isRotated={!isCollapsed}
          />
        </Stack>
        <Collapse isCollapsed={isCollapsed} keepCollapsedInDom={keepCollapsedInDom}>
          {renderCollapse()}
        </Collapse>
      </Stack>
    </Card>
  );
};

const ChildrenContainer = styled.div({
  flexGrow: 1,
});
